import { useNavigate } from "react-router-dom";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { ScheduleClient } from "../../web-api-client";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { appConfig } from "../../appconfig";

export function useDeleteSchedule() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const client = new ScheduleClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", {
              replace: true,
              state: { from: window.location.pathname },
            }),
        }),
      });
      return client.deleteScheduleSlot(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["schedules"] });
    },
  });
}
